import moment from "moment";

export var FINANCEIRO_PAINEL_FILTERS_KEY = "financeiro.painel";

// Defaults depend on "today", so they are built at mount (usePersistedFilters).
// Everything here is filtered client-side (GET /dashtasks brings the whole board).
export var getDefaultFinanceiroPainelFilters = function() {
  return {
    screen: "active",
    paymentStatus: "open", // all | open | overdue | paid
    selectedMonth: moment().format("YYYY-MM"), // null = todos os meses
    customRange: null, // { from: 'YYYY-MM-DD', to: 'YYYY-MM-DD' } when a custom period is chosen
    search: "",
  };
};

// The period that scopes the KPIs: custom range when set, otherwise the month.
export var getFinanceiroPeriod = function(filters) {
  return filters.customRange || filters.selectedMonth || null;
};

export var isFinanceiroPeriodDefault = function(filters, defaults) {
  return !filters.customRange && filters.selectedMonth === defaults.selectedMonth;
};

// Badge: only what differs from the defaults.
export var countActiveFinanceiroFilters = function(filters, defaults) {
  return (filters.paymentStatus !== defaults.paymentStatus ? 1 : 0) +
    (filters.screen !== defaults.screen ? 1 : 0) +
    (isFinanceiroPeriodDefault(filters, defaults) ? 0 : 1) +
    (filters.search ? 1 : 0);
};
